export enum YesOrNoEnum {
  YES = 'yes',
  NO = 'no',
  NOT_SURE = '',
}

export enum C2PRelationSourceType {
  Vitrina = 'Vitrina',
  Client = 'Client',
  HubSpot = 'HubSpot',
}

export enum C2PIngestionMethod {
  DELI = 'DELI',
  SelfService = 'SelfService',
}
